import React, { useState, useEffect } from "react";
import { Box, makeStyles, Button, Grid, FormHelperText } from "@material-ui/core";
import Page from "../../components/Page";
import TableEnseres from "./components/Enseres/TableEnseres";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import AddIcon from "@material-ui/icons/Add";
import sedeactual from "../../config/sedeactual";
import AddEnseres from "./components/Enseres/AddEnseres";
import { getFixedAssets, getCategoryType, getLocations } from "./requests";
import ExportarExcel from "../../components/Global/ExportarExcel";
import SelectLocations from "./SelectLocations";
import LoaderBackdrop from "../../components/Global/LoaderBackdrop";
import { Dropdown, notification } from "antd";
import { MenuDropDown } from "./Memorandums";

const useStyles = makeStyles((theme) => ({
  buttonDisable: {
    margin: "10px 0",
    backgroundColor: "#f0f0f0",
    color: "#BD1214",
  },
  buttonEnable: {
    margin: "10px 0",
    backgroundColor: "#f0f0f0",
    color: "#4caf50",
  },
}));

const typeAsset = "equipment";

const Enseres = () => {
  const classes = useStyles();
  const [idLocation, setIdLocation] = useState(null);
  const [nameLocation, setNameLocation] = useState(null);
  const [enseres, setEnseres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleModalAdd, setVisibleModalAdd] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [locations, setLocations] = useState([]);
  const [memorandum, setMemorandum] = useState({ open: false, type: "", data: [], keys: [] });

  const obtainData = async () => {
    try {
      const res = await getCategoryType(typeAsset);
      res.sort((a, b) => (a.name < b.name ? -1 : 1));
      setCategories(res);
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    }
  };

  const obtainAssets = async () => {
    setLoading(true);
    try {
      const result = await getFixedAssets(typeAsset, sedeactual.get(), isActive, idLocation);
      setEnseres(result);
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const obtainLocation = async () => {
    setLoading(true);
    try {
      const res = await getLocations();
      setLocations(res.data);
      if (res.data.length > 0) {
        setIdLocation(res.data[0]._id);
        setNameLocation(res.data[0].name);
      }
    } catch (error) {
      notification["error"]({
        message: "Ocurrió un error al obtener la información.",
        description: `${error}`,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtainData();
    obtainLocation();
  }, []);

  useEffect(() => {
    if (idLocation) {
      obtainAssets();
      const result = locations.find((e) => e._id === idLocation);
      setNameLocation(result.name);
    }
  }, [idLocation, isActive]);

  return (
    <Page
      title="ENSERES"
      helper="INVENTARIO"
      itemComponent={
        <>
          <Dropdown
            overlay={
              <MenuDropDown
                onClick={(e) => setMemorandum({ ...memorandum, open: true, type: e.key })}
              />
            }
            disabled={
              memorandum.data.length === 0 || sedeactual.getRol() === "usuario"
            }
          >
            <Button color="primary" variant="contained">
              MEMORANDUM
            </Button>
          </Dropdown>{" "}
          <Button
            className={!isActive ? classes.buttonEnable : classes.buttonDisable}
            variant="contained"
            onClick={() => setIsActive(!isActive)}
            disabled={!idLocation ? true : false}
          >
            {!isActive ? <PersonAddIcon /> : <PersonAddDisabledIcon />}
            {!isActive ? "HABILITADO" : "DESHABILITADO"}
          </Button>{" "}
          <Button
            variant="contained"
            color="primary"
            onClick={() => setVisibleModalAdd(true)}
            disabled={ sedeactual.getRol() === "usuario" || (idLocation ? false : true)}
          >
            <AddIcon /> AGREGAR
          </Button>{" "}
          <ExportarExcel
            name={`ENSERES_${Date.now().toString()}`}
            endpoint={`export-fixed-asset/${sedeactual.get()}/${typeAsset}/${idLocation}/${
              sedeactual.company().url
            }`}
            method="GET"
            disabled={loading || idLocation ? false : true}
            small={false}
            api={2}
          />
        </>
      }
    >
      {loading && <LoaderBackdrop />}
      {visibleModalAdd && (
        <AddEnseres
          visible={visibleModalAdd}
          setVisible={setVisibleModalAdd}
          reloadFunction={obtainAssets}
          categories={categories}
          idLocation={idLocation}
          sede={sedeactual.get()}
          company={sedeactual.company().url}
          setLoading={setLoading}
          loading={loading}
        />
      )}
      <br />
      <Grid container direction="row" justify="space-between" alignItems="center">
        <FormHelperText>LOCACIONES</FormHelperText>
        <SelectLocations
          defaultValue={idLocation}
          onChangeSelect={(e) => setIdLocation(e)}
          data={locations}
        />
      </Grid>
      <Box pb={1} />
      <TableEnseres
      onlyview={sedeactual.getRol() === "usuario"}
        dataTable={enseres}
        reloadFunction={obtainAssets}
        idLocation={idLocation}
        setLoading={setLoading}
        loading={loading}
        categories={categories}
        isActive={isActive}
        nameLocation={nameLocation}
        memorandum={memorandum}
        setMemorandum={setMemorandum}
      />
    </Page>
  );
};

export default Enseres;
